<template>
  <v-card flat>
    <template v-slot:text>
      <v-text-field
          v-if="missingProducts.length > 0"
          v-model="search"
          :prepend-inner-icon="mdiMagnify"
          variant="outlined"
          hide-details
          single-line
      ></v-text-field>
    </template>

    <v-data-table
        :headers="headers"
        :items="missingProducts"
        :search="search"
    >
      <template v-slot:item="{ item }">
        <tr :class="!item.isMissing?'text-disabled':''">
          <td v-if="showDebugMode">
            <v-chip v-if="!item.isMissing">
              {{ $t('mission-planning.info.last-reading.not-missing') }}
            </v-chip>
          </td>
          <td>{{ item.ean }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.category?.name }}</td>
          <td>
            <v-chip
                v-for="tag of item.tags"
                size="small"
                class="mx-1 my-1"
                :style="`background-color:${tags[tag]?.color}`"
                label
            >
              {{ tags[tag]?.label }}
            </v-chip></td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script setup>
import { computed, ref, inject } from 'vue';
import { mdiMagnify } from '@mdi/js';
import { useI18n } from 'vue-i18n';
import {useApplicationStore} from '@/stores/applicationStore';

const props = defineProps({
  reading: {
    required: false,
    default: []
  },
  pointOfSale: {
    required: true
  },
  tags: {
    required: true
  }
});
const { t } = useI18n();
const applicationStore = useApplicationStore();
const showDebugMode = computed(() => applicationStore.showDebugMode);
const search = ref('');
const headers = computed(() => {
  let output = [
    { align: 'start', key: 'ean', title: t('mission-planning.info.last-reading.ean') },
    { key: 'name', title: t('mission-planning.info.last-reading.product-name') },
    { key: 'categoryName', title: t('mission-planning.info.last-reading.category') },
    { key: 'tagsText', title: t('mission-planning.info.last-reading.tags') }
  ];
  if (showDebugMode.value) {
    output.unshift({ key: 'isMissing', title: '' })
  }
  return output;
})
const currentConfiguration = inject('currentConfiguration');

const missingProducts = computed(() => {
  const pointOfSaleProductIndicators = props.pointOfSale?.productIndicators?.dno || []
  const allProducts = currentConfiguration.value?.catalog?.product || {};
  const prevProductsIds = props.reading?.counters?.presentDNProductIds || []
  return Object.entries(allProducts).filter(
          ([key, val]) => pointOfSaleProductIndicators.includes(key.toString()) &&
              (!prevProductsIds.includes(key.toString()) || showDebugMode.value)
      ).map(
          ([key, val]) => {
            const categoryName = val?.category?.name ?? '';
            const tagsText = Array.isArray(val?.tags)
                ? val.tags.map(tagId => props.tags?.[tagId]?.label).filter(Boolean).join(' ')
                : '';
            return {
              ...val,
              categoryName,
              tagsText,
              isMissing: !prevProductsIds.includes(key.toString())
            }
          }
      );
})

</script>